import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const VarificationNewPopUp = (props) => {
  const {
    message,
    setVarificationNewPopUp,
    varificationPopUp,
    setVarificationNewMessage,
  } = props;

  const handleOk = () => {
    setVarificationNewPopUp(false);
    setVarificationNewMessage('');
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={varificationPopUp}>
      <DialogContent dividers>
        <Typography variant='h6'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VarificationNewPopUp;
